module.exports = __webpack_public_path__ + "581b1f1dff05f149859fe5d151760dd2.png";